export const getApiErrorMessage = (error, fallback) => (
  error?.response?.data?.detail
  || error?.message
  || fallback
);
